import React from 'react';
import ToggleSwitch from './ToggleSwitch';
import {useSelector, useDispatch} from 'react-redux';

const SettingsPanel = ({
    filtersTitle = 'Filters',
                           title = 'Settings',
                           filtersComponent = null,
                           settings = [],
                           sliceSelector,
                           showFilterSeparator = false,
                           settingsFirst = false
                       }) => {
    const dispatch = useDispatch();
    const slice = useSelector(sliceSelector);

    const filtersSection = (
        <>
            {filtersTitle && <h4 className="title">{filtersTitle}</h4>}
            {filtersComponent}
        </>
    );

    const settingsSection = (
        <div className="settings-container">
            {title && <h4 className="title">{title}</h4>}
            {settings.map((setting, index) =>
                setting.customComponent ? (
                    // Render custom JSX directly with key
                    <React.Fragment key={setting.id || index}>
                        {setting.customComponent}
                    </React.Fragment>
                ) : (
                    // Default: render ToggleSwitch
                    <div
                        key={setting.id || index}
                        className={`loudness-label-tooltip-container ${index === 0 ? 'first-setting' : ''}`}
                    >
                        <ToggleSwitch
                            id={setting.id}
                            checked={slice[setting.selector]}
                            onChange={(value) => dispatch(setting.action(value))}
                            label={setting.label}
                            tooltip={setting.tooltip}
                        />
                    </div>
                )
            )}
        </div>
    );

    return (
        <div className="description-container loudness-settings-container">
            {settingsFirst ? settingsSection : filtersSection}
            {showFilterSeparator && <div className="filter-settings-separator" />}
            {settingsFirst ? filtersSection : settingsSection}
        </div>
    );
};

export default SettingsPanel;
